import { memo } from 'react'
import { Panel } from 'reactflow'
import { Button } from "@/shared/components/ui/button"
import { Bot, GitBranch, Sparkles, Heart, Brain } from "lucide-react"

interface NodeToolbarProps {
  onAddAgentNode: () => void
  onAddStructuredAgentNode: () => void
  onAddCompanionAgentNode: () => void
  onAddPersonaAgentNode: () => void
  onAddRouterNode: () => void
  onAddBinderNode: () => void
  onAddHermesAgentNode: () => void
}

export const NodeToolbar = memo(({
  onAddAgentNode,
  onAddStructuredAgentNode,
  onAddCompanionAgentNode,
  onAddPersonaAgentNode,
  onAddRouterNode,
  onAddBinderNode,
  onAddHermesAgentNode,
}: NodeToolbarProps) => {
  
  return (
    <Panel position="top-left" className="flex gap-2">
      <Button 
        size="sm" 
        variant="secondary" 
        className="gap-2 shadow-md bg-white hover:bg-slate-50" 
        onClick={onAddAgentNode}
      >
        <Bot className="h-4 w-4" /> 基础智能体
      </Button>
      
      <Button 
        size="sm" 
        variant="secondary" 
        className="gap-2 shadow-md bg-teal-50 hover:bg-teal-100 border-teal-200 text-teal-700" 
        onClick={onAddStructuredAgentNode}
      >
        <Sparkles className="h-4 w-4" /> 自主智能体
      </Button>
      
      <Button
        size="sm"
        variant="secondary"
        className="gap-2 shadow-md bg-sky-50 hover:bg-sky-100 border-sky-200 text-sky-700"
        onClick={onAddCompanionAgentNode}
      >
        <Heart className="h-4 w-4" /> 陪伴智能体
      </Button>

      <Button 
        size="sm" 
        variant="secondary" 
        className="gap-2 shadow-md bg-violet-50 hover:bg-violet-100 border-violet-200 text-violet-700" 
        onClick={onAddPersonaAgentNode}
      >
        <span className="text-sm">🎭</span> 身份模拟
      </Button>
      
      <Button 
        size="sm" 
        variant="secondary" 
        className="gap-2 shadow-md bg-white hover:bg-slate-50" 
        onClick={onAddRouterNode}
      >
        <GitBranch className="h-4 w-4" /> 条件判断
      </Button>
      
      <Button 
        size="sm" 
        variant="secondary" 
        className="gap-2 shadow-md bg-cyan-50 hover:bg-cyan-100 border-cyan-200 text-cyan-700" 
        onClick={onAddBinderNode}
      >
        <span className="text-sm">🔗</span> 并行编排
      </Button>
      
      <Button 
        size="sm" 
        variant="secondary" 
        className="gap-2 shadow-md bg-purple-50 hover:bg-purple-100 border-purple-200 text-purple-700" 
        onClick={onAddHermesAgentNode}
      >
        <Brain className="h-4 w-4" /> 原生智能体
      </Button>
    </Panel>
  )
})

NodeToolbar.displayName = 'NodeToolbar'